import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-lg font-bold" }
const _hoisted_2 = { class: "flex gap-2 mt-4" }

import { ref, watch, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LbrxPrintConfirmModal',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "print", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isOpen = ref(props.open);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
  },
);

watch(isOpen, (newValue) => {
  emit("update:open", newValue);
});

const emit = __emit;

const print = () => {
  emit("print");
};
const cancel = () => {
  isOpen.value = false;
  emit("cancel");
};

const backgroundColor = ref("");

onMounted(() => {
  const bgColor = localStorage.getItem("themeTemplate");

  if (bgColor) {
    backgroundColor.value = JSON.parse(bgColor).primaryColor;
  } else {
    backgroundColor.value = "#fc8019";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    width: "600px",
    centered: "",
    open: isOpen.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("Pos.PrintConfirm")), 1)
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Pos.PrintConfirmMessage")), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "flex w-full rounded-md items-center justify-center text-white",
          style: _normalizeStyle({ backgroundColor: backgroundColor.value }),
          onClick: print
        }, _toDisplayString(_ctx.$t("Pos.Print")), 5),
        _createElementVNode("button", {
          class: "flex w-full rounded-md py-2 items-center justify-center",
          style: _normalizeStyle({
                border: `2px solid ${backgroundColor.value}`,
                color: backgroundColor.value,
                backgroundColor: 'transparent',
              }
        ),
          onClick: cancel
        }, _toDisplayString(_ctx.$t("Pos.Cancel")), 5)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})